import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box/Box';
import { Header } from '../../../../../../../components/header';
import { IconToastError } from '../../../../../../../components/icons/icon-toast-error';
import { IconToastSuccess } from '../../../../../../../components/icons/icon-toast-success';
import { useTariffConfigurationContext } from '../../../../channel-configuration/context/tariff-configuration-context';
import { ChartPie } from '../../components/chart-pie';
import { HeatmapLegend } from '../../components/heatmap-legend';
import { groupRangesByTimeZoneKind } from '../../utils';

export const ChartTariff: React.FC = () => {
  const { t } = useTranslation('channel-details');
  const { formValues } = useTariffConfigurationContext();
  const groups = groupRangesByTimeZoneKind(formValues.hoursRanges);
  const timeZones = Object.keys(groups);

  const renderBooleanItem = (value: boolean, translateKey: string) => (
    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '24px' }}>
      {value ? <IconToastSuccess /> : <IconToastError />}
      <span style={{ marginLeft: '12px' }}>{t(`optimizer.configuration.tariff.${translateKey}`)}</span>
    </Box>
  );

  return (
    <>
      <HeatmapLegend ranges={[0, 3, 6]} />
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          '@media (max-width: 850px)': {
            flexDirection: 'column',
          },
        }}
      >
        {timeZones.length === 1 && <ChartPie ranges={groups[timeZones[0]]} key={timeZones[0]} />}

        {timeZones.length > 1 &&
          timeZones.map((tz) => (
            <div key={tz} style={{ marginBottom: '24px', width: '100%' }}>
              <Header
                title={
                  tz === 'ALL' ? 'Cały rok' : t(`optimizer.configuration.tariff.${tz.toLowerCase()}Time`).toUpperCase()
                }
                center
              />
              <ChartPie ranges={groups[tz]} />
            </div>
          ))}
      </Box>
      {renderBooleanItem(formValues.wholeWeekendCheaper, 'wholeWeekendCheaper')}
      {renderBooleanItem(formValues.wholeHolidaysCheaper, 'wholeHolidaysCheaper')}
      {renderBooleanItem(formValues.ignoreSummerTimeChanges, 'ignoreSummerTimeChanges')}
    </>
  );
};
